import {useQuery} from "@tanstack/react-query";
import {readOverseasColumnSetting} from "../../../../../api/main/OcApi";

export const useReadOverseasColumnSetting = () => {
    const {data} = useQuery({
        queryKey: ["readOverseasColumnSetting"],
        queryFn: async () => await readOverseasColumnSetting(),
        select: (res) => res?.data.result ?? {overseasViewInfoVOList: []},
    });

    return {data};
};
